<script>
    export default {
        name: "TheDetailWrapper",
        props: {
            title: String,
            typeList: String,
            currentStatus: String,
        },
        computed: {
            nameButton() {
                let filtered = {
                    new: "Применить",
                    view: "В режим редактирования",
                    edit: "Обновить изменения",
                };
                return filtered[this.currentStatus];
            },
        },
        methods: {
            send() {
                this.$emit("handler-submit");
            },
        },
    };
</script>

<template>
    <section class="section">
        <div class="field">
            <b-button
                tag="router-link"
                size="is-small"
                :to="typeList"
                type="is-primary is-light"
            >
                К списку
            </b-button>
        </div>

        <h1 class="title">{{ title }}</h1>

        <slot></slot>

        <div class="field is-grouped">
            <p class="control">
                <b-button type="is-primary" size="is-medium" @click="send">
                    {{ nameButton }}
                </b-button>
            </p>
        </div>
    </section>
</template>

<style lang="scss"></style>
